<template>
  <div>
    <h3>{{name}}</h3>
    <div class="row" v-if="canEdit">
      <div class="col">
        <under-input v-model="item.name">
          Name
        </under-input>
      </div>
      <div class="col" v-if="!['Savage Worlds'].includes(ruleset)">
        <under-select v-model="item.school" :options="schools">
          School
        </under-select>
      </div>
      <div class="col-3" v-if="['Savage Worlds', 'Savage Embers'].includes(ruleset)">
        <under-select v-model="item.rank" :options="rankOptions">
          Rank
        </under-select>
      </div>
      <div class="col-2" v-else>
        <under-input v-model.number.lazy="item.level" type="number" maxlength="1" min="0" max="10">
          Level
        </under-input>
      </div>
        <div class="col-3 text-center" v-if="canEdit && ['PF Playtest', 'PFRPG2', 'Embers RPG'].includes(ruleset)">
        <pf-actions v-model="item.actions">Actions</pf-actions>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <under-input v-model="item.detail">
          ( Detail )
        </under-input>
      </div>

      <div class="col-2" v-if="['PFRPG', 'PFRPG2', 'PF Playtest', 'Embers RPG'].includes(ruleset) && item.level && item.level > 0">
        <under-input v-model.number.lazy="item.maximum" type="number" maxlength="1" min="0" max="20">
          Prepared
        </under-input>
      </div>

      <div class="col-2 text-center" v-else>
        <under-checkbox v-model="item.prepared">
          Prepared
        </under-checkbox>
      </div>
    </div>

    <under-input v-if="canEdit" v-model="item.summary" maxlength="255">
      Summary
    </under-input>
    <under-text-area-md v-if="canEdit" v-model="item.description" rows="6">
      Description
    </under-text-area-md>    

  </div>
</template>
<script>
import { mapGetters } from "vuex";
import PfActions from "../shared/_PfActions.vue";
import UnderCheckbox from "../shared/_UnderCheckbox.vue";
import UnderInput from "../shared/_UnderInput.vue";
import UnderSelect from "../shared/_UnderSelect.vue";
import UnderTextAreaMd from "../shared/_UnderTextAreaMd.vue";

export default {
  name: "sections-spells-default",
  components: {
    PfActions,
    UnderCheckbox,
    UnderInput,
    UnderSelect,
    UnderTextAreaMd,
  },
  props: ["section", "item", "ruleset"],
  watch: {
    "item.maximum": "setCurrent",
  },
  computed: {
    ...mapGetters({
      charactersCanEdit: "characters/canEdit",
    }),
    name() {
      var label = ["Savage Worlds"].includes(this.ruleset) ? "Power" : "Spell";
      return this.canEdit ? label : this.item.name;
    },
    canEdit() {
      return this.charactersCanEdit && this.item.stock !== true;
    },
    schools() {
      let options = [];
      /* eslint-disable-next-line vue/no-side-effects-in-computed-properties */
      this.$rulesets[this.ruleset].spellSchools.forEach((element) => {
        options.push({ text: element, value: element });
      });
      return options;
    },
    rankOptions() {
      let options = [{ text: "", value: "" }];
      this.$rulesets[this.ruleset].rankOptions.forEach((element) => {
        options.push({ text: element, value: element });
      });
      return options;
    },
  },
  methods: {
    setCurrent() {
      this.item.current = this.item.maximum;
    },
  },
};
</script>
